import { useState } from 'react'
import cn from 'clsx'

// Components
import { Button } from '@tracklib/kit'
import { Form, Input, baseFormValidation } from 'components/form'

import styles from './passwordform.css'

type Values = {
  old_password: string
  new_password1: string
  new_password2: string
}

const validate = (values: Values) => {
  const errors = baseFormValidation({
    required: { fields: ['old_password', 'new_password1', 'new_password2'] },
    length: {
      fields: ['new_password1'],
      options: [9],
      message: 'This password is too short. It must contain at least 9 characters.',
    },
  })(values)

  const { new_password1, new_password2 } = values
  if (new_password1 !== new_password2) {
    errors.new_password2 = 'Passwords must match'
  }
  return errors
}

export const newPasswordDescription = 'Use 9 or more characters including at least one letter'

type PasswordformProps = {
  onSubmit: (data: { old_password: string; new_password1: string; new_password2: string }) => Promise<Record<string, unknown>>
}

const PasswordForm = ({ onSubmit }: PasswordformProps): JSX.Element => {
  const [success, setSuccess] = useState(false)
  const initialValues: Values = {
    old_password: '',
    new_password1: '',
    new_password2: '',
  }
  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      onDone={() => {
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 3000)
      }}
      validate={validate}
    >
      {({ isSubmitting, submitButtonProps }) => (
        <>
          <h2>Change password</h2>
          <div className="col">
            <Input name="old_password" label="Current password" type="password" autoComplete="current-password" disabled={isSubmitting} />
            <div>
              <Input
                name="new_password1"
                label="New password"
                type="password"
                autoComplete="new-password"
                disabled={isSubmitting}
                description={newPasswordDescription}
              />
              <Input name="new_password2" label="Confirm password" type="password" autoComplete="new-password" disabled={isSubmitting} />
            </div>
          </div>
          <footer className={styles.footer}>
            <div className={cn(styles.toast, success && styles.toastSuccess)} datatesting="password_change_success">
              Password changed successfully!
            </div>
            <Button {...submitButtonProps} datatesting="button_change_password" className="saveBtn">
              Change password
            </Button>
          </footer>
        </>
      )}
    </Form>
  )
}

export default PasswordForm
